import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import HorizontalSteps from '../components/HorizontalSteps';
import About from '../components/About';
import Calculators from '../components/Calculators';
import Testimonials from '../components/Testimonials';
import Pricing from '../components/Pricing';
import ProjetoX from '../components/ProjetoX';
import Location from '../components/Location';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen grain-texture">
      <Header />
      <Hero />
      <HorizontalSteps />
      <About />
      <Calculators />
      <Pricing />
      <Testimonials />
      <ProjetoX />
      <Location />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
